export interface LanguageOption {
  image: string;
  name: string;
  value: string;
}

export const selectorList: LanguageOption[] = [
  { image: 'assets/images/flag/en.png', name: 'English', value: 'en' },
  { image: 'assets/images/flag/ms.png', name: 'English', value: 'my' },
  { image: 'assets/images/flag/id.png', name: 'Indonesian', value: 'id' },
  { image: 'assets/images/flag/th.png', name: 'ไทย', value: 'th' },
  { image: 'assets/images/flag/vi.png', name: 'Tiếng Việt', value: 'vi' },
  { image: 'assets/images/flag/in.png', name: 'हिन्दी', value: 'in' },
  { image: 'assets/images/flag/jp.png', name: '日本語', value: 'jp' },
  { image: 'assets/images/flag/kr.png', name: '한국어', value: 'kr' },
];

export const languageList: string[] = ['en', 'vi', 'th', 'id', 'my', 'in', 'jp', 'kr'];
